"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _ProfilePhoto = _interopRequireDefault(require("./ProfilePhoto"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "size-xs": "DefaultTheme__size-xs___2K5Po",
  "size-s": "DefaultTheme__size-s___1npOD",
  "size-m": "DefaultTheme__size-m___7KpF0",
  "size-l": "DefaultTheme__size-l___1q8h0",
  "size-xl": "DefaultTheme__size-xl___3jl1g",
  "size-xxl": "DefaultTheme__size-xxl___2rTVR",
  "profile-photo": "DefaultTheme__profile-photo___2w7np",
  "sizeXs": "DefaultTheme__size-xs___2K5Po",
  "sizeS": "DefaultTheme__size-s___1npOD",
  "sizeM": "DefaultTheme__size-m___7KpF0",
  "sizeL": "DefaultTheme__size-l___1q8h0",
  "sizeXl": "DefaultTheme__size-xl___3jl1g",
  "sizeXxl": "DefaultTheme__size-xxl___2rTVR",
  "profilePhoto": "DefaultTheme__profile-photo___2w7np"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "profile-photo": "DarkTheme__profile-photo___1TJPd",
  "profilePhoto": "DarkTheme__profile-photo___1TJPd"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)('ProfilePhoto', themes.DefaultTheme)(_ProfilePhoto["default"]);
ThemedComponent.displayName = 'ProfilePhoto';
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map